var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var TDDeleteButton = createReactClass({
	propTypes: {
		id: PropTypes.node.isRequired,
		show: PropTypes.bool,
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired
	},
	change: function() {
		this.props.onChange({
			action: "delete",
			id: this.props.id
		});
	},
	render: function() {
		var button = null;
		if(this.props.show) {
			button = (
				<button type="button"
					className="btn btn-danger btn-sm btn-icon-only"
					onClick={this.change}
					disabled={this.props.disabled}
				>
						<span className="fa fa-times no-text"
							aria-hidden="true"/>
				</button>
			);
		}

		return (
			<td className="text-center actions">
				<div className="form-group">
					{button}
				</div>
			</td>
		)
	}
});

module.exports = TDDeleteButton;
